import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import "./couponmodal.css";
import { Coupons } from "../../../utils/apis/master/Master";
import { Context } from "../../../utils/context";
import Common_Button from "../../Common-Component/Common_Button/Common_Button";

const CoupanModal = ({
  show,
  handleClose,
  setError,
  getCouponCode,
  varient_amount,
  product_id,
  setModalShowCoupon,
  setDiscount,
  setCouponError,
  setMessage,
  message,
  setCardError,
  setCoupon,
  setCouponStatus,
  totalPrice,
  shippingCharges,
  coupon,
  totalAmount,
  couponErrors,
  variant_id,
  m_variant_id,
  discount,
}) => {
  

  const { IMG_URL } = useContext(Context);
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    const fetchCoupons = async () => {
      const res = await Coupons();
      if (res?.success) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set the time to the start of the day
        const validCoupons = res.data.filter((item) => {
          const expirationDate = new Date(item.e_date);
          expirationDate.setHours(0, 0, 0, 0);

          return expirationDate >= today;
        });
        setCoupons(validCoupons);
      }
    };
    fetchCoupons();
  }, []);

  const onSubmit = async (data) => {
    setError("code", "");
    const res = await getCouponCode(
      data?.code,
      totalAmount,
      product_id,
      variant_id,
      m_variant_id
    );

    if (res?.success) {
      if (res?.couponCode) {
        setModalShowCoupon(true);
        setCoupon(res?.couponCode?.id);
        setCouponStatus(true);
        if (res?.couponCode?.type === "fixedamount") {
          setDiscount(res?.couponCode?.total_amount);
          setMessage(`Coupon Applied of Rs. ${res?.couponCode?.total_amount}`);
        } else {
          const discountPercentage = Number(res?.couponCode?.discount) || 0;
          const price = Number(totalPrice) + Number(shippingCharges) || 0;
          const discountAmount = price * (discountPercentage / 100);
          setDiscount(discountAmount);
          setMessage(`${discountPercentage} % Discount Applied`);
          setCardError("");
        }

        setTimeout(() => {
          setModalShowCoupon(false);
          setMessage("");
          setCardError("");
        }, 3000);
      }
      setCouponError("");
    } else {

      setCouponError(res?.message ? res?.message : "Coupon Not Available");
      setDiscount(0);
      setCoupon("");
      setCouponStatus(false);
      setError("code", { message: "Coupon Invalid" });
      setCardError("");
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      centered
      className="couponmoddd"
    >
      <Modal.Header closeButton>
        <Modal.Title>Coupons</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12  mb-2">
            <div className="">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Control
                  placeholder="Coupon Code"
                  value={coupon}
                  onChange={(e) => {
                    setCoupon(e.target.value);
                    setCouponError("");
                  }}
                />
              </Form.Group>
            </div>
            <div className="text-center">
              <Common_Button
                className={"SubmitBtn"}
                text={"Apply Coupon"}
                onClick={() => onSubmit({ code: coupon })}
              />
            </div>
          </div>
          <p className="text-danger text-center">{couponErrors}</p>

          {coupons.map((item, index) => (
            <div key={index} className="col-xxl-12 col-xl-12 col-lg-12  mb-2">
              <div className="card coupancard">
                <div className="card-body">
                  <div className="row">
                    <div className="col-3">
                      <div className="main-images">
                        <div className="image">
                          <img
                            className="card-img"
                            src={`${IMG_URL}${item?.image}`}
                            alt="Logo"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-9">
                      <div className="card-details">
                        <h3 className="offer_text">{item.name}</h3>
                      </div>
                      <h6>
                        {" "}
                        <p className="sub_title">{item.coupon_message}</p>
                      </h6>
                      {item?.type === "percentage" ? (
                        <p className="coupdet">
                          {/* <b>{item.discount}%</b> */}
                          get {item.discount}% off on the minimum order of ₹
                          {item?.minimum_order}
                        </p>
                      ) : (
                        <p className="coupdet">
                          {/* <b>₹ {item.total_amount}</b> */}
                          get ₹ {item.total_amount} off on the minimum order of
                          ₹{item?.minimum_order}
                        </p>
                      )}

                      <div>
                        <p className="coupon_code_text">
                          {" "}
                          Coupon Code : <b>{item.code}</b>
                        </p>
                      </div>

                      <div>
                        <p className="coupon_code_text">
                          {" "}
                          Order Amount : <b>{totalAmount}</b>
                        </p>
                      </div>

                      <div className="coupancode_holder">
                        {totalPrice >= item?.minimum_order ? (
                          <div className="coupancode_btn">
                            <p
                              className="codetxt"
                              onClick={() => onSubmit({ code: item.code })}
                            >
                              Apply Coupon
                            </p>
                          </div>
                        ) : (
                          <sub className="text text-danger">
                            Order amount should be atleast ₹
                            {item?.minimum_order}
                          </sub>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* <Button variant="secondary" onClick={handleClose}>
          Close
        </Button> */}
      </Modal.Body>
    </Modal>
  );
};

export default CoupanModal;
